'use client';

import {useNavigate} from '@tanstack/react-router';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import {Dialog, DialogContent} from '@features/ui/components/dialog';
import {Button} from '@features/ui/components/Button';
import amplitudeService from '@features/analytics/amplitudeService';

/**
 * Shown when the user's subscription is `past_due`. Generation and export are
 * locked until the payment goes through — this modal replaces the buy/upgrade
 * paywall on every action that would otherwise prompt to purchase.
 */
export function PastDueModal({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='max-w-md'>
        <DialogPrimitive.Title className='sr-only'>
          Subscription past due
        </DialogPrimitive.Title>
        <div className='px-6 pb-6 pt-5'>
          <div className='space-y-4 text-sm text-gray-600'>
            <p className='pr-6 text-xl font-semibold leading-snug text-foreground'>
              Your subscription is past due
            </p>
            <p>
              We couldn&apos;t process your latest payment, so generating and
              exporting designs is locked. Update your payment details to unlock
              everything again.
            </p>
          </div>
          <div className='mt-6 flex flex-col gap-2'>
            <Button
              size='sm'
              className='w-full'
              onClick={() => {
                amplitudeService.logEvent(
                  '[Past Due] billing settings clicked',
                );
                onOpenChange(false);
                void navigate({to: '/settings', search: {tab: 'subscription'}});
              }}
            >
              Go to billing settings
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
